(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["revery-cart-upsell"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-rv-upsell-add]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        if (!variantId) return;
        btn.disabled = true;
        try {
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          });
          if (r.ok) {
            btn.textContent = 'Added';
            btn.dataset.rvAdded = '1';
            setTimeout(() => location.reload(), 600);
          } else {
            btn.textContent = 'Try again';
            btn.disabled = false;
          }
        } catch (err) {
          btn.textContent = 'Try again';
          btn.disabled = false;
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["revery-free-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function(){
  if (window.__rvShipBarInit) return;
  window.__rvShipBarInit = true;

  function fmt(cents){
    var aed = (cents/100);
    return 'AED ' + (aed % 1 === 0 ? aed.toFixed(0) : aed.toFixed(2));
  }

  function setUnlocked(bar, txt){
    bar.classList.add('is-unlocked');
    while (txt.firstChild) txt.removeChild(txt.firstChild);
    txt.textContent = 'Complimentary delivery unlocked.';
  }

  function setRemaining(bar, txt, remaining){
    bar.classList.remove('is-unlocked');
    while (txt.firstChild) txt.removeChild(txt.firstChild);
    var prefix = document.createElement('span');
    prefix.textContent = 'Add ';
    var amt = document.createElement('strong');
    amt.textContent = fmt(remaining);
    var suffix = document.createElement('span');
    suffix.textContent = ' for complimentary delivery.';
    txt.appendChild(prefix);
    txt.appendChild(amt);
    txt.appendChild(suffix);
  }

  function update(){
    document.querySelectorAll('[data-rv-shipbar]').forEach(function(bar){
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 20000;
      fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
        var remaining = Math.max(0, threshold - c.total_price);
        var pct = Math.min(100, Math.round((c.total_price / threshold) * 100));
        var fill = bar.querySelector('[data-rv-shipbar-fill]');
        var txt = bar.querySelector('[data-rv-shipbar-text]');
        if (fill) fill.style.width = pct + '%';
        if (!txt) return;
        if (remaining <= 0) setUnlocked(bar, txt);
        else setRemaining(bar, txt, remaining);
      }).catch(function(){});
    });
  }

  document.addEventListener('cart:update', update);
  document.addEventListener('cart:refresh', update);
  document.addEventListener('cart:change', update);
  ['ajaxCart.afterCartLoad','cart:item-added'].forEach(function(ev){ document.addEventListener(ev, update); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["revery-meta-events"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__rvMetaEventsInit) return;
    window.__rvMetaEventsInit = true;

    var ctx = window.__RV_META_CTX__ || {};
    var fbq = function () {
      try { if (typeof window.fbq === 'function') window.fbq.apply(null, arguments); } catch (_) {}
    };

    /* === ViewSubscription === fired when a subscription-eligible PDP loads */
    if (ctx.product && (ctx.product.requiresSellingPlan || ctx.product.sellingPlanCount > 0 || /subscription|subscribe/.test(ctx.product.tags || ''))) {
      fbq('trackCustom', 'ViewSubscription', {
        content_type: 'subscription',
        content_ids: [String(ctx.product.variantId)],
        content_name: ctx.product.title,
        content_category: ctx.product.type,
        value: ctx.product.priceAed,
        predicted_ltv: ctx.product.priceAed * 12, /* assume 12-month avg lifetime */
        currency: ctx.currency
      });
    }

    /* Custom ViewContent removed — Shopify's native channel fires
       ViewContent on PDPs with full CAPI dedup. Our extra browser-side
       call had no matching event_id, so CAPI coverage dropped below
       75% and Meta reported worse cost-per-result. */

    /* === Contact (custom) === fired on any WhatsApp deeplink click */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com/"]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var intent = 'help';
      if (/I'd like to buy|to order|buy on whats/i.test(href)) intent = 'buy';
      else if (/event|wedding/i.test(href)) intent = 'event';
      else if (/workshop/i.test(href)) intent = 'workshop';
      else if (/subscription/i.test(href)) intent = 'subscription';
      fbq('trackCustom', 'Contact', {
        content_type: 'whatsapp_click',
        content_name: 'WhatsApp · ' + intent,
        content_category: intent,
        source_page: window.location.pathname,
        value: intent === 'buy' ? 200 : intent === 'event' ? 500 : intent === 'subscription' ? 150 : 50,
        currency: 'AED'
      });
    }, true);

    /* === AddToCart enrichment for subscription detection ===
       Listens to the same submit pattern as the EMQ booster but inspects
       the cart line for a selling_plan and emits a custom SubscriptionAddedToCart
       so Meta can build a "subscription intender" audience. */
    document.addEventListener('rv:cart-add-success', function (e) {
      var item = e && e.detail && e.detail.item;
      if (!item) return;
      if (item.selling_plan_allocation || (item.properties && item.properties._selling_plan_id)) {
        fbq('trackCustom', 'SubscriptionAddedToCart', {
          content_type: 'subscription',
          content_ids: [String(item.variant_id || item.id)],
          content_name: item.product_title || item.title,
          value: (item.price || 0) / 100,
          predicted_ltv: ((item.price || 0) / 100) * 12,
          currency: 'AED'
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["revery-meta-match-booster"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__rvMetaMatchInit) return;
    window.__rvMetaMatchInit = true;

    var KEY = 'rv:meta_match';

    function readStored() {
      try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (_) { return {}; }
    }
    function writeStored(d) {
      try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (_) {}
    }
    function looksLikeEmail(v) {
      return typeof v === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
    }
    function looksLikePhone(v) {
      return typeof v === 'string' && /^\+?[\d\s().-]{7,20}$/.test(v.trim());
    }

    /* Push captured identifiers into the Meta pixel via Advanced Matching.
       Calls fbq('init', ID, {...}) which merges userData but does NOT fire
       a new PageView/Purchase. Shopify's channel keeps owning event firing. */
    function applyToPixel(data) {
      if (!window.fbq || !window._fbq || !window._fbq.instance) return false;
      var ids = Object.keys(window._fbq.instance.pixelsByID || {});
      if (!ids.length) return false;
      var userData = {};
      if (data.email) userData.em = data.email.trim().toLowerCase();
      if (data.phone) userData.ph = data.phone.replace(/[^\d+]/g, '');
      if (data.first_name) userData.fn = data.first_name.trim().toLowerCase();
      if (data.last_name) userData.ln = data.last_name.trim().toLowerCase();
      if (!Object.keys(userData).length) return false;
      ids.forEach(function (id) { window.fbq('init', id, userData); });
      return true;
    }

    function applyWhenReady(data) {
      if (applyToPixel(data)) return;
      /* Defer until Shopify's pixel loads. Cap at 30 retries (~3s). */
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (applyToPixel(data) || tries > 30) clearInterval(iv);
      }, 100);
    }

    /* Re-apply stored identifiers on every page load so the customer
       stays identified across pageviews. */
    var stored = readStored();
    if (stored.email || stored.phone) applyWhenReady(stored);

    /* Capture from any input that looks like an email/phone. Hooks
       into newsletter, inquiry, gift recipient and any other form. */
    function captureFromInput(input) {
      if (!input) return;
      var val = (input.value || '').trim();
      if (!val) return;
      var current = readStored();
      var changed = false;
      if (looksLikeEmail(val) && current.email !== val) { current.email = val; changed = true; }
      if (looksLikePhone(val) && current.phone !== val) { current.phone = val; changed = true; }
      if (changed) {
        writeStored(current);
        applyWhenReady(current);
      }
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.value) return;
      if (t.type === 'email' || t.type === 'tel') {
        captureFromInput(t);
      } else if (t.tagName === 'INPUT' && (looksLikeEmail(t.value) || looksLikePhone(t.value))) {
        captureFromInput(t);
      }
    });

    /* Form submissions are a stronger signal — capture every field with
       a recognised value. Also classify the form and fire a Lead event
       so Meta discovers the event on the very first submission. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.querySelectorAll) return;
      form.querySelectorAll('input').forEach(captureFromInput);
      fireLeadIfApplicable(form);
    }, true);

    /* Classify the form and fire fbq('track','Lead',...) once per submit.
       Skips Shopify cart/checkout/login/search forms. */
    function fireLeadIfApplicable(form) {
      if (!window.fbq || typeof window.fbq !== 'function') return;
      var action = (form.action || '').toLowerCase();
      // Skip non-lead forms
      if (/\/cart|\/checkout|\/account|\/search|\/products\/.*\/add/.test(action)) return;
      if (form.dataset.rvNoLead === 'true') return;

      var formType = 'Contact form';
      var leadValue = 50;
      // Detect form type by hidden inputs (we use contact[form_type] or contact[lead_type] convention)
      var formTypeInput = form.querySelector('input[name="contact[form_type]"], input[name="contact[lead_type]"]');
      if (formTypeInput && formTypeInput.value) {
        var v = formTypeInput.value.toLowerCase();
        if (v.indexOf('newsletter') !== -1)        { formType = 'Newsletter signup';     leadValue = 5; }
        else if (v.indexOf('event') !== -1)        { formType = 'Event inquiry';        leadValue = 200; }
        else if (v.indexOf('wedding') !== -1)      { formType = 'Wedding inquiry';      leadValue = 500; }
        else if (v.indexOf('workshop') !== -1)     { formType = 'Workshop registration'; leadValue = 100; }
        else if (v.indexOf('inquiry') !== -1)      { formType = 'General inquiry';      leadValue = 50; }
        else if (v.indexOf('subscription') !== -1) { formType = 'Subscription inquiry'; leadValue = 150; }
      }
      // Fallback detection if no explicit type field
      else if (/newsletter|subscribe/.test(form.className) || /newsletter|subscribe/.test(form.id || '')) {
        formType = 'Newsletter signup'; leadValue = 5;
      }
      else if (form.querySelector('[name="contact[event_type]"]')) {
        formType = 'Event inquiry'; leadValue = 200;
      }
      else if (form.querySelector('[name="contact[brief]"], [name="contact[event_date]"]')) {
        formType = 'Wedding / event lead-gen'; leadValue = 300;
      }

      // Capture email/phone to pass with the event for stronger matching
      var emailInput = form.querySelector('input[type="email"], input[name*="email"]');
      var phoneInput = form.querySelector('input[type="tel"], input[name*="phone"], input[name*="contact"]');
      var email = emailInput && emailInput.value && looksLikeEmail(emailInput.value) ? emailInput.value : '';
      var phone = phoneInput && phoneInput.value && looksLikePhone(phoneInput.value) ? phoneInput.value : '';
      if (email || phone) {
        var current = readStored();
        if (email && current.email !== email) current.email = email;
        if (phone && current.phone !== phone) current.phone = phone;
        writeStored(current);
        applyWhenReady(current);
      }

      try {
        window.fbq('track', 'Lead', {
          content_name: formType,
          content_category: 'form_submission',
          value: leadValue,
          currency: 'AED'
        });
      } catch (_) {}
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["revery-reviews"] && !Shopify.designMode) return;
  try {
    (function() {
    var widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;
    var observer = new MutationObserver(function() {
      if (widget.children.length > 0) {
        document.body.classList.add('jdgm--has-reviews');
        observer.disconnect();
      }
    });
    observer.observe(widget, { childList: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["revery-scroll-reveal"] && !Shopify.designMode) return;
  try {
    (function() {
  if (typeof IntersectionObserver === 'undefined') {
    document.querySelectorAll('.rv-reveal, [data-rv-reveal]').forEach(function(el) {
      el.classList.add('rv-reveal--in');
    });
    return;
  }
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('rv-reveal--in');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  function bind() {
    document.querySelectorAll('.rv-reveal:not(.rv-reveal--in), [data-rv-reveal]:not(.rv-reveal--in)').forEach(function(el) {
      observer.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
})();
  } catch(e) { console.error(e); }
})();

})();
